import * as FormActions from './form';
import * as ListActions from './list';

export default {
    ...FormActions,
    ...ListActions
};